import { render } from "./FieldsListDropdown.vue?vue&type=template&id=5d1f5014&scoped=true"
import script from "./FieldsListDropdown.vue?vue&type=script&lang=js"
export * from "./FieldsListDropdown.vue?vue&type=script&lang=js"

import "./FieldsListDropdown.vue?vue&type=style&index=0&id=5d1f5014&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1f5014"]])

export default __exports__